import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router";

/**
 * BrowserRouter keeps the window's scroll position across route changes, so
 * following a link opened the next page partway down. Start each newly
 * visited page at the top. Back/forward (POP) is left alone so the browser can
 * return the reader to where they were, a link to a section of another page
 * goes to that section, and query-only changes (filters, tabs) keep the
 * current position.
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    // Only a new page counts; navigationType also changes on query-only
    // navigations, so it can't drive this on its own.
    if (previousPathname.current === pathname) return;
    previousPathname.current = pathname;
    if (navigationType === "POP") return;
    // The router doesn't scroll to fragments. Go to the section if it's
    // already rendered; otherwise start at the top and let the page's
    // useScrollToHash take over once its content mounts.
    const target = hash ? document.getElementById(hash.slice(1)) : null;
    if (target) target.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);

  return null;
};
